export const RadioOptionKeys = {
  HeatingCostsInvoice: {
    None: 'none',
    Personal: 'personal',
    Professional: 'professional_other'
  },
  CentralHeatingAvailable: {
    Yes: 'centralheating_yes',
    No: 'centralheating_no'
  },
  HotWaterDeliveryCentral: {
    Yes: 'hotwaterdeliverycentral_yes',
    No: 'hotwaterdeliverycentral_no'
  },
  HeatingType: {
    RadiatorOnly: 'radiator',
    UnderFloorHeatingOnly: 'underfloor_heating',
    RadiatorAndUnderfloorHeating: 'radiator_underfloor_heating'
  },
  ContactOptions: {
    Male: 'male',
    Female: 'female'
  }
};

const translationKeyMapping = [
  {
    optionKey: RadioOptionKeys.HeatingCostsInvoice.None,
    translationKey: 'radioOptionHeatingCostsInvoiceNotYet'
  },
  {
    optionKey: RadioOptionKeys.HeatingCostsInvoice.Personal,
    translationKey: 'radioOptionHeatingCostsInvoiceSelf'
  },
  {
    optionKey: RadioOptionKeys.HeatingCostsInvoice.Professional,
    translationKey: 'radioOptionHeatingCostsInvoiceServiceProvider'
  },
  {
    optionKey: RadioOptionKeys.CentralHeatingAvailable.Yes,
    translationKey: 'radioOptionCentralHeatingAvailable',
    offerTranslationKey: 'radioOptionCentralHeatingAvailableOfferText',
    summaryTranslationKey: 'radioOptionCentralHeatingAvailableSummaryText'
  },
  {
    optionKey: RadioOptionKeys.CentralHeatingAvailable.No,
    translationKey: 'radioOptionCentralHeatingNotAvailable',
    offerTranslationKey: 'radioOptionCentralHeatingNotAvailableOfferText',
    summaryTranslationKey: 'radioOptionCentralHeatingNotAvailableSummaryText'
  },
  {
    optionKey: RadioOptionKeys.HotWaterDeliveryCentral.Yes,
    translationKey: 'radioOptionHotWaterDeliveryCentrally',
    offerTranslationKey: 'radioOptionHotWaterDeliveryCentrallyOfferText',
    summaryTranslationKey: 'radioOptionHotWaterDeliveryCentrallySummaryText'
  },
  {
    optionKey: RadioOptionKeys.HotWaterDeliveryCentral.No,
    translationKey: 'radioOptionHotWaterDeliveryNotCentrally',
    offerTranslationKey: 'radioOptionHotWaterDeliveryNotCentrallyOfferText',
    summaryTranslationKey: 'radioOptionHotWaterDeliveryNotCentrallySummaryText'
  },
  {
    optionKey: RadioOptionKeys.HeatingType.RadiatorOnly,
    translationKey: 'radioOptionHeatingTypeRadiatorOnly'
  },
  {
    optionKey: RadioOptionKeys.HeatingType.UnderFloorHeatingOnly,
    translationKey: 'radioOptionHeatingTypeUnderFloorHeatingOnly'
  },
  {
    optionKey: RadioOptionKeys.HeatingType.RadiatorAndUnderfloorHeating,
    translationKey: 'radioOptionHeatingTypeRadiatorAndUnderfloorHeating'
  },
  {
    optionKey: RadioOptionKeys.ContactOptions.Male,
    translationKey: 'radioOptionContactDetailsSalutationMale'
  },
  {
    optionKey: RadioOptionKeys.ContactOptions.Female,
    translationKey: 'radioOptionContactDetailsSalutationFemale'
  }
];

export function translationKeyForRadioOption(radioOption: string) {
  var entry = translationKeyMapping.find((item) => item.optionKey === radioOption);
  if (entry) {
    return entry.translationKey;
  }
  console.warn('Translation Key Not set for radio option ' + radioOption + '!');
  return '';
}

export function offerTranslationKeyForRadioOption(radioOption: string) {
  var entry = translationKeyMapping.find((item) => item.optionKey === radioOption);
  if (entry) {
    // Return summary translation key only in case the summary text differs from the radio option text.
    return entry.offerTranslationKey ? entry.offerTranslationKey : entry.translationKey;
  }
  console.warn('Translation Key Not set for radio option ' + radioOption + '!');
  return '';
}

export function summaryTranslationKeyForRadioOption(radioOption: string) {
  var entry = translationKeyMapping.find((item) => item.optionKey === radioOption);
  if (entry) {
    // Return summary translation key only in case the summary text differs from the radio option text.
    return entry.summaryTranslationKey ? entry.summaryTranslationKey : entry.translationKey;
  }
  console.warn('Translation Key Not set for radio option ' + radioOption + '!');
  return '';
}
